import React from "react";
import homeSection02Bg01 from "@/shared/assets/img/home-sec02-bg01.png";

/**
 * Section2 - Digital Hybrid Learning Class (디지털 하이브리드 학습방)
 * Displays 3 key features with numbered cards and decorative elements
 */
export const Section2: React.FC = () => {
  return (
    <section className="w-full bg-gradient-to-b from-white to-orange-50/30 py-8 lg:py-8 relative">
      {/* Background Image */}
      <div>
        <img
          src={homeSection02Bg01}
          alt="Background decoration"
          className="w-full h-full object-cover lg:object-contain"
        />
      </div>
    </section>
  );
};
